import React, { FunctionComponent } from 'react';
import { ThemeContext } from '../providers/ThemeContext';

interface BoardProps {
    id: string;
    className: string;
    onDrop?: any;
    onDragOver?: any;
}

const Board: FunctionComponent<BoardProps> = (props) => {

    const { darkMode } = React.useContext(ThemeContext);

    const drop = (e: any) => {
        e.preventDefault();

        const cardId = e.dataTransfer.getData('cardId');

        const card = document.getElementById(cardId);

        e.target.appendChild(card);
    }

    const dragOver = (e: any) => {
        e.preventDefault();

    }

    return (
        <div
            id={props.id}
            className={props.className}
            onDrop={drop}
            onDragOver={dragOver}
            style={{
                color: darkMode? 'whitesmoke': '#121212'
            }}
        >
            {props.children}
        </div>
    );
}

export default Board;